import { Button } from '@/components/shadcn/button'
import { TooltipButton } from '@/components/ui/TooltipButton'
import { IconWorkflowOutline } from '@icons/IconWorkflowOutline'

interface GroupingActionsV2Props {
  isRegrouping: boolean
  canRegroup: boolean
  onToggleRegrouping: () => void
  onSaveGroups: () => void
  onCancelGroups: () => void
  isSubmittingGroups: boolean
}

export function GroupingActionsV2({
  isRegrouping,
  canRegroup,
  onToggleRegrouping,
  onSaveGroups,
  onCancelGroups,
  isSubmittingGroups,
}: GroupingActionsV2Props) {
  if (!canRegroup) return null

  const regroupButton = (
    <TooltipButton tooltip="Group items">
      <Button
        size="icon"
        variant={isRegrouping ? 'default' : 'ghost'}
        className="size-8"
        onClick={onToggleRegrouping}
      >
        <IconWorkflowOutline className="size-4" />
      </Button>
    </TooltipButton>
  )

  const saveAndCancelButtons = (
    <>
      <Button size="sm" onClick={onSaveGroups} disabled={isSubmittingGroups}>
        Save Groups
      </Button>
      <Button size="sm" variant="outline" onClick={onCancelGroups}>
        Cancel
      </Button>
    </>
  )

  return isRegrouping ? saveAndCancelButtons : regroupButton
}
